<template>
  <section class="mb-5">
    <div class="mt-2 mb-4 border-bottom">
      <h2 class="display-4">Die Geräte</h2>
      <h5>
        <strong>Insgesamt</strong>
        <span class="text-primary px-2">{{ totalColumns }}</span
        >Geräte auf <span class="text-primary px-2">{{ devicePages }}</span
        >Seite/n
      </h5>
    </div>
    <!-- Button trigger modal -->
    <span class="me-2">Neu Gerät hinzufügen:</span>
    <button
      type="button"
      title="Neu Gerät hinzufügen"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#modalFormDevices"
    >
      <i class="fa-solid fa-sm fa-plus"></i>
    </button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modalFormDevices"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="modalFormDevicesLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalFormDevicesLabel">
              Neues Gerät hinzufügen
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="marker" class="form-label">Marke</label>
              <input
                type="text"
                class="form-control"
                id="marker"
                v-model="data.marker"
              />
            </div>
            <div class="mb-3">
              <label for="series" class="form-label">Serie</label>
              <input
                type="text"
                class="form-control"
                id="series"
                v-model="data.series"
              />
            </div>
            <div class="mb-3">
              <label for="name" class="form-label">Name</label>
              <input
                type="text"
                class="form-control"
                id="name"
                v-model="data.name"
              />
            </div>

            <div class="mb-3">
              <label for="formFile" class="form-label">Gerätefoto</label>
              <input
                class="form-control"
                type="file"
                @change="handleFiles"
                id="formFile"
              />
            </div>
            <div class="mb-3">
              <label for="state" class="form-label">Status</label>
              <select
                id="state"
                v-model="data.state"
                class="form-select"
                aria-label="Default select example"
              >
                <option value="0">Nicht verfügbar</option>
                <option value="1">verfügbar</option>
              </select>
            </div>
          </div>
          <div class="modal-footer" data-bs-dismiss="modal">
            <button type="button" class="btn btn-link">Abbrechen</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="addOrEditDevice"
            >
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Device cards -->
    <div
      class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 d-flex justify-content-center my-2"
      v-if="devices"
    >
      <div class="col" v-for="(item, index) in devices" :key="index">
        <div class="card border-0 h-100">
          <img
            v-if="item.thumbnail"
            :src="$store.state.config.endpoint + item.thumbnail"
            class="card-img-top"
            :alt="item.thumbnail"
          />
          <div class="card-body pt-0 pb-0" v-if="devices">
            <p v-if="item.marker" class="card-text mb-0" title="Marke">
              <small class="text-primary"
                ><i class="fa-solid fa-sm fa-mobile-screen-button"></i>
                {{ item.marker }}</small
              >
            </p>
            <h5 class="card-title" title="Gerätename">{{ item.name }}</h5>
            <p v-if="item.series" class="card-muted small mb-0" title="Serie">
              Serie: {{ item.series }}
            </p>
            <select class="m-2 ms-0 form-select-sm" v-model="item.state" aria-label="Default select example">
                <option value="0">Nicht verfügbar</option>
                <option value="1">verfügbar</option>
            </select>
            <div
              class="btn-group btn-group-sm"
              role="group"
              aria-label="Basic example"
            >
              <button
                class="btn btn-outline-primary"
                title="Speichern"
                @click="changeDeviceState(item)"
              >
                <i class="fa-solid fa-sm fa-floppy-disk"></i>
              </button>
              <button
                type="button"
                title="Bearbeiten"
                @click="data = item"
                class="btn btn-outline-success"
                data-bs-toggle="modal"
                data-bs-target="#modalFormDevices"
              >
                <i class="fa-solid fa-sm fa-pen-to-square"></i>
              </button>
              <button
                class="btn btn-outline-dark"
                title="Löschen"
                @click="deleteDevice(item, index)"
              >
                <i class="fa-solid fa-sm fa-trash"></i>
              </button>
            </div>
          </div>
          <div class="card-body" v-else>
            <h5 class="card-title placeholder-glow">
              <span class="placeholder col-6"></span>
            </h5>
            <p class="card-text placeholder-glow">
              <span class="placeholder col-7"></span>
              <span class="placeholder col-4"></span>
              <span class="placeholder col-4"></span>
              <span class="placeholder col-6"></span>
              <span class="placeholder col-8"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center my-4">
      <ul class="pagination">
        <li class="page-item" v-for="page in devicePages" :key="page">
          <button class="page-link" @click="openPage(page)">{{ page }}</button>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "Devices",

  data() {
    return {
      perPage: 25,
      totalColumns: 0,
      lastColumns: 0,
      devicePages: 0,
      devices: undefined,
      data: {
        marker: "",
        series: "",
        name: "",
        thumbnail: undefined,
        state: 1,
      },
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadDevices();
    });
  },

  watch: {},

  methods: {
    loadDevices() {
      this.$store.state.modules.api
        .loadDevices(this.perPage, this.lastColumns)
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            this.devices = resp.data.units;
            this.totalColumns = resp.data.total;
            this.devicePages = Math.ceil(this.totalColumns / this.perPage);
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },

    openPage(num) {
      this.lastColumns = (num - 1) * this.perPage;
      this.loadDevices();
    },

    handleFiles(event) {
      if (event.target.files[0].size < 10000000) {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          this.$store.state.modules.api
            .uploadDeviceThumbnail(reader.result)
            .then((resp) => {
              if (resp.status == 200) {
                this.data.thumbnail = resp.data.thumbnail;
                console.log(this.data.thumbnail);
              } else {
                this.$store.state.utils.setNewNotifications(
                  {
                    type: "warning",
                    title: "Fehlermeldung",
                    message: "Etwas ist schief gelaufen. :(",
                  },
                  2500
                );
              }
            })
            .catch((err) => {
              console.error(err);
            });
        };
        reader.onerror = (error) => {
          console.error("Error: ", error);
        };
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "info",
            title: "Bildgröße",
            message: "Das maximale Bildgröße beträgt 10MB",
          },
          2500
        );
      }
    },

    addOrEditDevice() {
      console.log(this.data);
      this.$store.state.modules.api
        .addOrEditDevice(this.data)
        .then((resp) => {
          if (resp.status == 200) {
            if (resp.data.new) {
              this.devices.push(resp.data.unit);
            }

            this.data = {
              marker: "",
              series: "",
              name: "",
              thumbnail: undefined,
              state: 1,
            };

            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Neues Gerät",
                message: "Das Gerät wurde erfolgreich hinzugefügt",
              },
              2500
            );
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                title: "Fehlermeldung",
                message: "Etwas ist schief gelaufen. :(",
              },
              2500
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    changeDeviceState(item) {
      this.$store.state.modules.api
        .changeDeviceState(item)
        .then((resp) => {
          // console.log(resp);
          if (resp.status == 200) {
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Gerätestatus",
                message: "Status wurde zu " + item.state + " geändert",
              },
              2500
            );
          }
        })
        .catch((err) => {});
    },

    deleteDevice(item, index) {
      this.$store.state.modules.api
        .deleteDevice(item)
        .then((resp) => {
          // console.log(resp);
          if (resp.status == 200) {
            this.devices.splice(index, 1);
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Löschen",
                message: "Das Gerät wurde erfolgreich entfernt!",
              },
              2500
            );
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
